import React, { useState } from 'react';

import {
    Box,
    Breadcrumb,
    BreadcrumbItem,
    Button,
    Container,
    Flex,
    HStack,
    Icon,
    Input,
    Link,
    Text,
    Textarea,
    VStack,
    useBreakpointValue,
} from '@chakra-ui/react';

import {
    ChevronRightIcon,
    PhoneIcon,
    TimeIcon,
} from '@chakra-ui/icons';

import { MdMail, MdLocationPin } from 'react-icons/md';
import { Link as ReactLink } from 'react-router-dom';

import LeafletMap from '../components/LefletMap';


const Contact = () => {

    const bgPosition = useBreakpointValue({
        base: '30% 30%',
        md: '30% 40%',
    });

    const mapHeight = useBreakpointValue({
        base: '420px',
        md: '600px',
    });


    // FORM STATE
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [tphone, setTphone] = useState('');

    const [submitFailed, setSubmitFailed] = useState(false);
    const [submitSuccessful, setSubmitSuccessful] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);


    // VALIDÁCIÓ STATE
    const [firstNameIsInvalid, setFirstNameIsInvalid] = useState(false);
    const [lastNameIsInvalid, setLastNameIsInvalid] = useState(false);
    const [emailIsInvalid, setEmailIsInvalid] = useState(false);
    const [phoneIsInvalid, setPhoneIsInvalid] = useState(false);
    const [messageIsInvalid, setMessageIsInvalid] = useState(false);


    const emailRegex = new RegExp(
        /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );


    // VALIDÁCIÓ
    const isValid = () => {

        const firstNameValid = firstName.trim().length >= 2;
        const lastNameValid = lastName.trim().length >= 2;
        const phoneValid = tphone.trim().length >= 6;
        const emailValid = emailRegex.test(email.trim());
        const messageValid =
            message.trim().length >= 2 &&
            message.trim().length <= 100;

        setFirstNameIsInvalid(!firstNameValid);
        setLastNameIsInvalid(!lastNameValid);
        setPhoneIsInvalid(!phoneValid);
        setEmailIsInvalid(!emailValid);
        setMessageIsInvalid(!messageValid);

        return (
            firstNameValid &&
            lastNameValid &&
            phoneValid &&
            emailValid &&
            messageValid
        );
    };


    // FORM KÜLDÉS
    const handleSubmit = async (e) => {

        e.preventDefault();

        setSubmitFailed(false);
        setSubmitSuccessful(false);

        if (!isValid()) {
            setSubmitFailed(true);
            return;
        }

        const data = {
            firstName: firstName.trim(),
            lastName: lastName.trim(),
            email: email.trim(),
            tphone: tphone.trim(),
            message: message.trim(),
        };

        try {

            setIsSubmitting(true);

            const res = await fetch(
                'https://laskoditeszta.hu/api/sendorderconfirmationemail/send-email',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data),
                }
            );

            if (res.ok) {

                setFirstName('');
                setLastName('');
                setTphone('');
                setEmail('');
                setMessage('');

                setSubmitSuccessful(true);
                setSubmitFailed(false);

            } else {

                setSubmitSuccessful(false);
                setSubmitFailed(true);
            }

        } catch (error) {

            console.error(
                'Hiba az email küldése közben:',
                error
            );

            setSubmitSuccessful(false);
            setSubmitFailed(true);

        } finally {

            setIsSubmitting(false);
        }
    };


    return (

        <Box
            maxW="8xl"
            mx="auto"
            p={{ base: 0, lg: 12 }}
            minH="100vh"
            fontFamily="'Poppins', sans-serif"
        >
            <Flex
                borderRadius={{ base: 0, md: '12px' }}
                align="center"
                backgroundImage={`
                    linear-gradient(
                        90deg,
                        rgba(20,20,20,0.55) 0%,
                        rgba(20,20,20,0.20) 55%,
                        rgba(20,20,20,0.05) 100%
                    ),
                    url('/images/kapcsolat5.png')
                `}
                backgroundSize="cover"
                backgroundPosition={bgPosition}
                minH={{
                    base: '220px',
                    md: '340px',
                }}
                px={{
                    base: 6,
                    md: 14,
                }}
                position="relative"
                overflow="hidden"
            >

                <Box zIndex={2}>

                    <Text
                        fontFamily="'Playfair Display', serif"
                        fontSize={{
                            base: '3xl',
                            md: '5xl',
                            lg: '6xl',
                        }}
                        lineHeight="1"
                        fontWeight="700"
                        color="white"
                        textShadow="0 3px 12px rgba(0,0,0,0.35)"
                    >
                        Kapcsolat
                    </Text>

                </Box>
                <Box
                    position="absolute"
                    zIndex={1}
                    top={{ base: '20px', md: '-30px' }}
                    left="0"
                    width={{ base: "150px", md: "350px" }}
                    height={{ base: "180px", md: "350px" }}
                    opacity={0.75}
                >

                    <svg
                        viewBox="0 0 200 200"
                        xmlns="http://www.w3.org/2000/svg"
                        width="100%"
                        height="100%"
                    >
                        <path
                            transform="translate(100 100)"
                            fill="#e63e3e"
                            d="
                                M35,-57
                                C48.4,-53,64.3,-49.7,74.9,-40.3
                                C85.4,-30.9,90.6,-15.4,90.7,0.1
                                C90.8,15.6,85.8,31.1,75.3,40.4
                                C64.7,49.7,48.4,52.8,35,60.9
                                C21.5,69,10.7,82.1,-1.7,85.1
                                C-14.2,88.1,-28.3,80.9,-39.5,71.4
                                C-50.6,61.9,-58.7,50.2,-66.7,38
                                C-74.8,25.7,-82.9,12.8,-85.5,-1.5
                                C-88.1,-15.9,-85.3,-31.7,-76.7,-43.2
                                C-68.2,-54.6,-53.9,-61.7,-40.2,-65.5
                                C-26.5,-69.3,-13.2,-70,-1.2,-67.9
                                C10.8,-65.8,21.7,-61,35,-57Z
                            "
                        />
                    </svg>

                </Box>

            </Flex>
            <Breadcrumb
                ms={{ base: 4, lg: 2 }}
                mt={4}
                fontSize={{
                    base: 'xs',
                    md: 'sm',
                }}
                spacing={{
                    base: '3px',
                    md: '8px',
                }}
                separator={
                    <ChevronRightIcon color="gray.400" />
                }
            >

                <BreadcrumbItem>

                    <ReactLink to="/">
                        Főoldal
                    </ReactLink>

                </BreadcrumbItem>

                <BreadcrumbItem isCurrentPage>

                    <ReactLink to="/kapcsolat">
                        Kapcsolat
                    </ReactLink>

                </BreadcrumbItem>

            </Breadcrumb>
            <Container
                maxW="container.xl"
                py={{
                    base: 10,
                    md: 16,
                }}
                px={{
                    base: 4,
                    md: 6,
                }}
            >

                <Flex
                    direction={{
                        base: 'column',
                        lg: 'row',
                    }}
                    gap={{
                        base: 10,
                        lg: 16,
                    }}
                    align="stretch"
                >
                    <Box
                        flex="0.8"
                        bg="gray.50"
                        borderRadius="xl"
                        p={{
                            base: 6,
                            md: 8,
                        }}
                    >

                        <Text
                            color="red.600"
                            fontSize="sm"
                            fontWeight="600"
                            letterSpacing="1.5px"
                            textTransform="uppercase"
                            mb={2}
                        >
                            Elérhetőségeink
                        </Text>

                        <Text
                            fontFamily="'Playfair Display', serif"
                            fontSize={{
                                base: '2xl',
                                md: '3xl',
                            }}
                            fontWeight="700"
                            color="gray.800"
                            mb={8}
                        >
                            Keressen minket bizalommal!
                        </Text>


                        <VStack
                            align="stretch"
                            spacing={7}
                        >
                            <Flex
                                align="flex-start"
                                gap={4}
                            >

                                <Flex
                                    w="44px"
                                    h="44px"
                                    borderRadius="full"
                                    bg="red.50"
                                    color="red.600"
                                    align="center"
                                    justify="center"
                                    flexShrink={0}
                                >
                                    <Icon
                                        as={MdLocationPin}
                                        boxSize={5}
                                    />
                                </Flex>

                                <Box>

                                    <Text
                                        fontSize="xs"
                                        color="gray.500"
                                        fontWeight="600"
                                        textTransform="uppercase"
                                        letterSpacing="1px"
                                        mb={1}
                                    >
                                        Cím
                                    </Text>

                                    <Text
                                        fontSize={{
                                            base: 'md',
                                            md: 'lg',
                                        }}
                                        fontWeight="500"
                                        color="gray.800"
                                    >
                                        4543 Laskod,
                                        Szabadság út 31.
                                    </Text>

                                </Box>

                            </Flex>
                            <Flex
                                align="flex-start"
                                gap={4}
                            >

                                <Flex
                                    w="44px"
                                    h="44px"
                                    borderRadius="full"
                                    bg="red.50"
                                    color="red.600"
                                    align="center"
                                    justify="center"
                                    flexShrink={0}
                                >

                                    <TimeIcon boxSize={4} />

                                </Flex>

                                <Box>

                                    <Text
                                        fontSize="xs"
                                        color="gray.500"
                                        fontWeight="600"
                                        textTransform="uppercase"
                                        letterSpacing="1px"
                                        mb={1}
                                    >
                                        Nyitvatartás
                                    </Text>

                                    <Text
                                        fontSize={{
                                            base: 'md',
                                            md: 'lg',
                                        }}
                                        fontWeight="500"
                                        color="gray.800"
                                    >
                                        Hétfőtől – szombatig
                                    </Text>

                                    <Text
                                        fontSize="sm"
                                        color="gray.500"
                                        mt={1}
                                    >
                                        6:00 – 16:00
                                    </Text>

                                </Box>

                            </Flex>
                            <Flex
                                align="flex-start"
                                gap={4}
                            >

                                <Flex
                                    w="44px"
                                    h="44px"
                                    borderRadius="full"
                                    bg="red.50"
                                    color="red.600"
                                    align="center"
                                    justify="center"
                                    flexShrink={0}
                                >

                                    <PhoneIcon boxSize={4} />

                                </Flex>

                                <Box>

                                    <Text
                                        fontSize="xs"
                                        color="gray.500"
                                        fontWeight="600"
                                        textTransform="uppercase"
                                        letterSpacing="1px"
                                        mb={2}
                                    >
                                        Telefonszám
                                    </Text>

                                    <VStack
                                        align="start"
                                        spacing={1}
                                    >

                                        <Link
                                            href="tel:+36302181850"
                                            fontSize={{
                                                base: 'md',
                                                md: 'lg',
                                            }}
                                            fontWeight="500"
                                            color="gray.800"
                                            _hover={{
                                                color: 'red.600',
                                                textDecoration: 'none',
                                            }}
                                        >
                                            +36 30 218 1850
                                        </Link>

                                        <Link
                                            href="tel:+36305090425"
                                            fontSize={{
                                                base: 'md',
                                                md: 'lg',
                                            }}
                                            fontWeight="500"
                                            color="gray.800"
                                            _hover={{
                                                color: 'red.600',
                                                textDecoration: 'none',
                                            }}
                                        >
                                            +36 30 509 0425
                                        </Link>

                                    </VStack>

                                </Box>

                            </Flex>
                            <Flex
                                align="flex-start"
                                gap={4}
                            >

                                <Flex
                                    w="44px"
                                    h="44px"
                                    borderRadius="full"
                                    bg="red.50"
                                    color="red.600"
                                    align="center"
                                    justify="center"
                                    flexShrink={0}
                                >

                                    <Icon
                                        as={MdMail}
                                        boxSize={5}
                                    />

                                </Flex>

                                <Box minW={0}>

                                    <Text
                                        fontSize="xs"
                                        color="gray.500"
                                        fontWeight="600"
                                        textTransform="uppercase"
                                        letterSpacing="1px"
                                        mb={2}
                                    >
                                        E-mail
                                    </Text>

                                    <VStack
                                        align="start"
                                        spacing={1}
                                    >

                                        <Link
                                            href="mailto:laskoditeszta@hu.inter.net"
                                            fontSize={{
                                                base: 'sm',
                                                sm: 'md',
                                                md: 'lg',
                                            }}
                                            fontWeight="500"
                                            color="gray.800"
                                            wordBreak="break-word"
                                            _hover={{
                                                color: 'red.600',
                                                textDecoration: 'none',
                                            }}
                                        >
                                            laskoditeszta@hu.inter.net
                                        </Link>

                                        <Link
                                            href="mailto:aranytoj@hu.inter.net"
                                            fontSize={{
                                                base: 'sm',
                                                sm: 'md',
                                                md: 'lg',
                                            }}
                                            fontWeight="500"
                                            color="gray.800"
                                            wordBreak="break-word"
                                            _hover={{
                                                color: 'red.600',
                                                textDecoration: 'none',
                                            }}
                                        >
                                            aranytoj@hu.inter.net
                                        </Link>

                                    </VStack>

                                </Box>

                            </Flex>

                        </VStack>

                    </Box>
                    <Box
                        flex="1.2"
                        p={{
                            base: 0,
                            lg: 4,
                        }}
                    >

                        <Text
                            color="red.600"
                            fontSize="sm"
                            fontWeight="600"
                            letterSpacing="1.5px"
                            textTransform="uppercase"
                            mb={2}
                        >
                            Írjon nekünk
                        </Text>

                        <Text
                            fontFamily="'Playfair Display', serif"
                            fontSize={{
                                base: '2xl',
                                md: '3xl',
                            }}
                            fontWeight="700"
                            color="gray.800"
                            mb={4}
                        >
                            Lépjen kapcsolatba velünk
                        </Text>

                        <Text
                            maxW="650px"
                            fontSize={{
                                base: 'sm',
                                md: 'md',
                            }}
                            lineHeight="1.8"
                            color="gray.600"
                            mb={8}
                        >
                            Amennyiben érdekli az együttműködési
                            lehetőség cégünkkel, vagy további
                            kérdése van, kérjük, vegye fel velünk
                            a kapcsolatot az alábbi űrlap
                            segítségével!
                        </Text>
                        {submitSuccessful && (

                            <Box
                                mb={6}
                                px={5}
                                py={4}
                                bg="green.50"
                                color="green.700"
                                borderRadius="lg"
                                fontSize="sm"
                                fontWeight="500"
                            >
                                Köszönjük! Üzenetét sikeresen
                                elküldtük.
                            </Box>

                        )}
                        {submitFailed && (

                            <Box
                                mb={6}
                                px={5}
                                py={4}
                                bg="red.50"
                                color="red.700"
                                borderRadius="lg"
                                fontSize="sm"
                                fontWeight="500"
                            >
                                Az üzenetet nem sikerült elküldeni.
                                Kérjük, ellenőrizze a megadott
                                adatokat!
                            </Box>

                        )}


                        <form onSubmit={handleSubmit}>

                            <VStack
                                spacing={5}
                                align="stretch"
                            >
                                <Flex
                                    direction={{
                                        base: 'column',
                                        md: 'row',
                                    }}
                                    gap={4}
                                >

                                    <Box flex="1">

                                        <Text
                                            fontSize="sm"
                                            fontWeight="500"
                                            color="gray.700"
                                            mb={2}
                                        >
                                            Vezetéknév *
                                        </Text>

                                        <Input
                                            value={lastName}
                                            onChange={(e) => {
                                                setLastName(e.target.value);
                                                setLastNameIsInvalid(false);
                                            }}
                                            isInvalid={lastNameIsInvalid}
                                            placeholder="Vezetéknév"
                                            size="lg"
                                            borderRadius="md"
                                            fontSize="sm"
                                            _focus={{
                                                borderColor: 'red.500',
                                                boxShadow:
                                                    '0 0 0 1px var(--chakra-colors-red-500)',
                                            }}
                                        />

                                        {lastNameIsInvalid && (
                                            <Text
                                                color="red.500"
                                                fontSize="xs"
                                                mt={1}
                                            >
                                                Legalább két karakter
                                                szükséges.
                                            </Text>
                                        )}

                                    </Box>


                                    <Box flex="1">

                                        <Text
                                            fontSize="sm"
                                            fontWeight="500"
                                            color="gray.700"
                                            mb={2}
                                        >
                                            Keresztnév *
                                        </Text>

                                        <Input
                                            value={firstName}
                                            onChange={(e) => {
                                                setFirstName(e.target.value);
                                                setFirstNameIsInvalid(false);
                                            }}
                                            isInvalid={firstNameIsInvalid}
                                            placeholder="Keresztnév"
                                            size="lg"
                                            borderRadius="md"
                                            fontSize="sm"
                                            _focus={{
                                                borderColor: 'red.500',
                                                boxShadow:
                                                    '0 0 0 1px var(--chakra-colors-red-500)',
                                            }}
                                        />

                                        {firstNameIsInvalid && (
                                            <Text
                                                color="red.500"
                                                fontSize="xs"
                                                mt={1}
                                            >
                                                Legalább két karakter
                                                szükséges.
                                            </Text>
                                        )}

                                    </Box>

                                </Flex>
                                <Flex
                                    direction={{
                                        base: 'column',
                                        md: 'row',
                                    }}
                                    gap={4}
                                >

                                    <Box flex="1">

                                        <Text
                                            fontSize="sm"
                                            fontWeight="500"
                                            color="gray.700"
                                            mb={2}
                                        >
                                            E-mail cím *
                                        </Text>

                                        <Input
                                            type="email"
                                            value={email}
                                            onChange={(e) => {
                                                setEmail(e.target.value);
                                                setEmailIsInvalid(false);
                                            }}
                                            isInvalid={emailIsInvalid}
                                            placeholder="pelda@email.hu"
                                            size="lg"
                                            borderRadius="md"
                                            fontSize="sm"
                                            _focus={{
                                                borderColor: 'red.500',
                                                boxShadow:
                                                    '0 0 0 1px var(--chakra-colors-red-500)',
                                            }}
                                        />

                                        {emailIsInvalid && (
                                            <Text
                                                color="red.500"
                                                fontSize="xs"
                                                mt={1}
                                            >
                                                Kérjük, érvényes
                                                e-mail címet adjon meg.
                                            </Text>
                                        )}

                                    </Box>


                                    <Box flex="1">

                                        <Text
                                            fontSize="sm"
                                            fontWeight="500"
                                            color="gray.700"
                                            mb={2}
                                        >
                                            Telefonszám *
                                        </Text>

                                        <Input
                                            type="tel"
                                            value={tphone}
                                            onChange={(e) => {
                                                setTphone(e.target.value);
                                                setPhoneIsInvalid(false);
                                            }}
                                            isInvalid={phoneIsInvalid}
                                            placeholder="+36 30 123 4567"
                                            size="lg"
                                            borderRadius="md"
                                            fontSize="sm"
                                            _focus={{
                                                borderColor: 'red.500',
                                                boxShadow:
                                                    '0 0 0 1px var(--chakra-colors-red-500)',
                                            }}
                                        />

                                        {phoneIsInvalid && (
                                            <Text
                                                color="red.500"
                                                fontSize="xs"
                                                mt={1}
                                            >
                                                Legalább hat karakter
                                                szükséges.
                                            </Text>
                                        )}

                                    </Box>

                                </Flex>
                                <Box>

                                    <Flex
                                        justify="space-between"
                                        align="center"
                                        mb={2}
                                    >

                                        <Text
                                            fontSize="sm"
                                            fontWeight="500"
                                            color="gray.700"
                                        >
                                            Üzenet *
                                        </Text>

                                        <Text
                                            fontSize="xs"
                                            color={
                                                message.length > 100
                                                    ? 'red.500'
                                                    : 'gray.400'
                                            }
                                        >
                                            {message.length}/100
                                        </Text>

                                    </Flex>

                                    <Textarea
                                        value={message}
                                        onChange={(e) => {
                                            setMessage(e.target.value);
                                            setMessageIsInvalid(false);
                                        }}
                                        isInvalid={messageIsInvalid}
                                        placeholder="Írja meg üzenetét..."
                                        minH="160px"
                                        resize="vertical"
                                        borderRadius="md"
                                        fontSize="sm"
                                        _focus={{
                                            borderColor: 'red.500',
                                            boxShadow:
                                                '0 0 0 1px var(--chakra-colors-red-500)',
                                        }}
                                    />

                                    {messageIsInvalid && (
                                        <Text
                                            color="red.500"
                                            fontSize="xs"
                                            mt={1}
                                        >
                                            Az üzenet minimum 2,
                                            maximum 100 karakter lehet.
                                        </Text>
                                    )}

                                </Box>
                                <Button
                                    type="submit"
                                    width="100%"
                                    colorScheme="red"
                                    size="lg"
                                    borderRadius="md"
                                    fontWeight="600"
                                    fontSize="md"
                                    mt={2}
                                    isLoading={isSubmitting}
                                    loadingText="Küldés..."
                                    _hover={{
                                        bg: 'red.600',
                                        transform: 'translateY(-1px)',
                                        boxShadow: 'md',
                                    }}
                                    transition="all 0.2s ease"
                                >
                                    Küldés
                                </Button>

                            </VStack>

                        </form>

                    </Box>

                </Flex>

            </Container>
            <Container
                maxW="container.xl"
                px={{
                    base: 0,
                    md: 6,
                }}
                pb={{
                    base: 8,
                    md: 14,
                }}
            >

                <Box
                    overflow="hidden"
                    borderRadius={{
                        base: 0,
                        md: 'xl',
                    }}
                    boxShadow={{
                        base: 'none',
                        md: '0 8px 30px rgba(0,0,0,0.08)',
                    }}
                >

                    <LeafletMap
                        height={mapHeight}
                    />

                </Box>

            </Container>

        </Box>
    );
};

export default Contact;